import {BaseApiService} from "../../../../infrastructure/domain-services/base-api-service";

export class LanguageApi extends BaseApiService {
  url() {
    const url: String = ``;

    return url;
  }
}

